import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col } from 'antd';

import { SectionWrapper } from 'common/components';
import { useGetWalmartProductAssets } from '../../queries';
import ImageUrlCard from './ImageUrlCard';
import ProductImageModal from './ProductImageModal';
import ButtonAddImageUrl from './ButtonAddImageUrl';
import './styles.less';

const SelectProductImageUrlInputMultiple = (props) => {
  const { onChange, value, productId } = props;

  const [isProductImageModalVisible, setIsProductImageModalVisible] =
    useState(false);
  const [selected, setSelected] = useState([]);

  const toggleProductImageModal = () => {
    setIsProductImageModalVisible((prev) => !prev);
  };

  const { data: productImageData, isLoading } = useGetWalmartProductAssets({
    productId,
    enabled: isProductImageModalVisible,
  });

  const flattenProductImageData = useMemo(() => {
    return productImageData?.reduce(
      (combinedList, imageCategory) =>
        combinedList.concat(imageCategory?.assetInfos || []),
      []
    );
  }, [JSON.stringify(productImageData)]);

  const onInputChange = () => {
    if (selected?.length === 0) {
      onChange(null);
    } else {
      const selectedImages = flattenProductImageData?.filter((imageItem) =>
        selected?.includes(imageItem?.digitalAssetId)
      );

      const selectedImageUrl = selectedImages?.map((item) => {
        const imageFile = item?.thumb1000 || item?.originalFile;
        return item?.assetName === 'Walmart placeholder image'
          ? imageFile
          : window.origin + imageFile;
      });

      if (selectedImageUrl) {
        onChange(selectedImageUrl);
      }
    }

    toggleProductImageModal();
  };

  useEffect(() => {
    const checkIfProductImageItemInValueList = (productImageItem) => {
      return value?.some((valueItem) =>
        valueItem.includes(productImageItem?.thumb1000)
      );
    };

    //* map value to selected state
    const setSelectedByValue = () => {
      const selectedImage = flattenProductImageData
        ?.filter(checkIfProductImageItemInValueList)
        ?.map((item) => item?.digitalAssetId);

      if (selectedImage) {
        setSelected(selectedImage);
      }
    };

    setSelectedByValue();
  }, [JSON.stringify(value), JSON.stringify(flattenProductImageData)]);

  const handRemoveImage = (thumb1000) => {
    const newImageList = value?.filter((item) => item !== thumb1000);
    onChange(newImageList);
  };

  const handleEditImage = () => {
    toggleProductImageModal();
  };

  return (
    <div>
      {value ? (
        <RenderImageUrlMultiple
          value={value}
          handleRemoveImage={handRemoveImage}
          handleEditImage={handleEditImage}
        />
      ) : (
        <ButtonAddImageUrl onClick={toggleProductImageModal} />
      )}
      <>
        <ProductImageModal
          multiple={true}
          toggleProductImageModal={toggleProductImageModal}
          visible={isProductImageModalVisible}
          onSubmitSelectedImages={onInputChange}
          productImageData={productImageData}
          selected={selected}
          setSelected={setSelected}
          isProductImageModalVisible={isProductImageModalVisible}
          isLoading={isLoading}
        />
      </>
    </div>
  );
};

const RenderImageUrlMultiple = ({
  value,
  handleRemoveImage,
  handleEditImage,
}) => {
  return (
    <SectionWrapper style={{ padding: 0 }} containerStyle={{ padding: 13 }}>
      {value?.length > 0 && (
        <Row>
          <Col style={{ flex: 1, marginBottom: 10 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {value?.map((valueItem) => (
                <ImageUrlCard
                  thumb1000={valueItem}
                  handleRemoveImage={handleRemoveImage}
                />
              ))}
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={24}>
          <ButtonAddImageUrl onClick={handleEditImage} multiple={true} />
        </Col>
      </Row>
    </SectionWrapper>
  );
};

export default SelectProductImageUrlInputMultiple;
